import { render } from "./SalePaymentPlanTable.vue?vue&type=template&id=dbbe8a16&scoped=true"
import script from "./SalePaymentPlanTable.vue?vue&type=script&lang=js"
export * from "./SalePaymentPlanTable.vue?vue&type=script&lang=js"

import "./SalePaymentPlanTable.vue?vue&type=style&index=0&id=dbbe8a16&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbbe8a16"]])

export default __exports__